import { useState, useEffect } from "react";
import React from "react";
import logo from "../logo.webp";
import { Link, useLocation } from "react-router-dom";
export default function NavbarD() {



    const DATA_BLOG = [
        {
            heading: "Do You Need Help with Individual Tax Returns in the USA?",
            description: "Filing individual tax returns can often feel overwhelming, especially when faced with the complexity of US tax regulations and the intricacies of tax filing itself. Whether you’re a working professional, freelancer, or small business owner, understanding the process is crucial to avoid errors and make the most of your eligible deductions",
            url: "https://sbataxconsultants.com/blog/do-you-need-help-with-individual-tax-returns-in-the-usa/",
            imageURL: "https://sbataxconsultants.com/blog/wp-content/uploads/2025/01/24-1-1.jpg"
        },
        {
            heading: "Tax Deadline Extended to February 2025: Is Your State on the List?",
            description: "If you live in one of the states affected by severe weather or natural disasters in 2023, you may be eligible for an extended tax return filing USA deadline. The IRS has granted an extension until February 3, 2025, for taxpayers in certain areas of Louisiana, Vermont, and all of Puerto Rico and the Virgin Islands. This extension also applies to parts of Arizona, Connecticut, Illinois, Kentucky, Minnesota, Missouri, Montana, New York, Pennsylvania, South Dakota, Texas, and Washington State.",
            url: "https://sbataxconsultants.com/blog/tax-return-filing-usa-deadline-extended-to-feb-2025/",
            imageURL: "https://sbataxconsultants.com/blog/wp-content/uploads/2025/01/Tax-Deadline-Extended-to-February02-1-1920x1080.jpg"


        },
        {
            heading: "Tax Filing Services for First-Time Filers in USA",
            description: "Filing taxes for the first time can feel overwhelming, especially when you’re unsure of where to start. Between forms, deductions, and deadlines, it’s easy to get lost in the process. But here’s the good news—there are plenty of resources and services out there to make the process smoother, and we’re here to guide you through it. ",
            url: "https://sbataxconsultants.com/blog/tax-filing-services-for-first-time-filers-in-usa/",
            imageURL: "https://sbataxconsultants.com/blog/wp-content/uploads/2025/01/2-1.jpg"

        }
    ]


    // Function to truncate text
    const truncateText = (text, limit = 100) => {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
    };


    const handleReadMore = (index) => {
        console.log('index', DATA_BLOG[index].url)
        window.location.href = DATA_BLOG[index].url; // Replace with your desired URL

    }

    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const location = useLocation();

    // Function to toggle the dropdown
    const toggleDropdown = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    // Function to close the dropdown
    const closeDropdown = () => {
        setDropdownOpen(false);
    };

    // Function to close the dropdown on mobile devices
    const closeDropdownOnMobile = () => {
        if (window.innerWidth < 768) {
            closeDropdown();
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);
    return (
        <>

            <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-white z-9999999999">
                <div className="container d-flex ">
                    <a className="navbar-brand" href="/">
                        <img src={logo} className="img-fluid" alt="sba tax consultant logo" />
                    </a>
                    <button className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#main_nav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={toggleDropdown}>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse${isDropdownOpen ? ' show' : ''}`} id="main_nav">
                        <ul className="navbar-nav  ms-auto">

                            <li className="nav-item"><span onClick={closeDropdownOnMobile} className="nav-link"><Link to="/">Home</Link></span></li>

                            <li className="nav-item"><span onClick={closeDropdownOnMobile} className="nav-link"><Link to="./about-us"> About Us </Link></span></li>









                            <li className="nav-item dropdown has-megamenu ">
                                <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                                    Services
                                </a>

                                <div className="dropdown-menu megamenu ps-5 " style={{ marginTop: "-2px" }} role="menu">
                                    <div className="col-md-12 mb-0 row wwd">
                                        <h5 className=" col-md-7  text-left gradient-text">What We Do</h5>
                                        <h5 className=" col-md-5 text-left gradient-text-1">Latest Post</h5>
                                    </div>





                                    <div className="row mb-3">
                                        <div className="col-md-7">






                                            <div className="row">

                                                <div className="col-md-6 hline">
                                                    <ul className="list-unstyled new-list">
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./corporate-registration" className="new-link fw-bold text-dark" >Corporation Registration
                                                            <span className="d-block small " >Legally establish your corporation as a separate entity.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./sales-tax" className="new-link fw-bold text-dark" >Sales Tax
                                                            <span className="  d-block small">Ensure compliance with sales tax regulations.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./license" className="new-link fw-bold text-dark" >License
                                                            <span className="  d-block small">Obtain necessary business licenses for legal operation.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./bookkeeping-and-business-consulting" className="new-link fw-bold text-dark" >Bookkeeping & Business Consulting
                                                            <span className="  d-block small">Manage finances and get expert business advice.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./accounting" className="new-link fw-bold text-dark" >Accounting
                                                            <span className="d-block small">Get expert help to manage your finances.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./irs-related-works" className="new-link fw-bold text-dark" >ITIN/IRS Related Works
                                                            <span className="  d-block small">Get assistance with ITIN applications and IRS-related tasks.</span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>





                                                <div className="col-md-6 ">

                                                    <ul className="list-unstyled new-list">
                                                        <li>
                                                                <Link onClick={closeDropdownOnMobile} to="./tax-filing" className="new-link fw-bold text-dark">Tax Filing
                                                                    <span className="  d-block small">Accurately file your taxes on time and stay compliant.</span>
                                                                </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./tax-consultation" className="new-link fw-bold text-dark">Tax Consultation
                                                                <span className="  d-block small">Get expert advice on tax planning and savings.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./payroll-services" className="new-link fw-bold text-dark">Payroll Service
                                                            <span className="  d-block small">Ensure accurate and timely employee payroll management.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./insurance" className="new-link fw-bold text-dark">Insurance
                                                            <span className="  d-block small">Protect your business with the right insurance coverage.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./nri-services" className="new-link fw-bold text-dark">NRI Service
                                                            <span className="  d-block small">Expert financial and tax services tailored for NRIs.</span>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link onClick={closeDropdownOnMobile} to="./401k-assistance" className="new-link fw-bold text-dark">401K Assistance
                                                            <span className=" d-block small">Guidance on 401K retirement planning.</span>
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                </div>

                                            </div>


                                        </div>

                                        <h5 className=" col-md-3 gradient-text-sm">Latest Post</h5>



                                        <div className="col-md-5">
                                            <div className="blog-section mt-3">
                                                {DATA_BLOG.map((blog, index) => (

                                                    <div key={index} className="blog-post mb-4 me-2 d-flex flex-column flex-sm-row align-items-start ">
                                                        <div className="me-3 mb-3 mb-sm-0 new-blog" >
                                                            <img
                                                                src={blog.imageURL}
                                                                alt="Blog"
                                                                className="img-fluid rounded "
                                                            />
                                                        </div>

                                                        <div className="d-flex flex-column">
                                                            <h5 className="h6 mb-1 text-truncate new-blog-head" style={{ maxWidth: "250px", whiteSpace: "nowrap", overflow: "hidden" }}>
                                                                {blog.heading}
                                                            </h5>

                                                            <p className="small text-muted mb-1 me-5 new-blog-desc">
                                                                {truncateText(blog.description)}
                                                            </p>

                                                            <span
                                                                className="text-decoration-none read-more"
                                                                onClick={() => handleReadMore(index)}
                                                            >
                                                                Read more
                                                                <i className="bi bi-box-arrow-up-right ms-2"></i>
                                                            </span>
                                                        </div>
                                                    </div>

                                                ))}
                                            </div>


                                        </div>

                                    </div>

                                    <div className="separator"></div>



                                    <div className="row pt-3 align-items-center " style={{ lineHeight: "50px" }}>
                                        <div className="col-md-4 ps-5 border-end">
                                            <a href="/appointment" className="custom-link">
                                                <h5>Book Consultation
                                                    <i className="bi bi-chat-dots ms-2"></i>
                                                </h5>
                                            </a>
                                        </div>

                                        <div className="col-md-4 ps-5 border-end">
                                            <a href="tel:+919967623999" className="custom-link custom-link-2-color">
                                                <h5>
                                                    <i className="bi bi-telephone-forward me-3"></i>
                                                    +91 99676 23999
                                                </h5>
                                            </a>
                                        </div>

                                        <div className="col-md-4 ps-5">
                                            <a href="https://api.whatsapp.com/send?phone=+1%20469%20722%205480&text=Hi%20I%20have%20query%20about%20%20" className="custom-link custom-link-3-color">
                                                <h5>Chat with Expert
                                                    <i className="bi bi-chat-text ms-2"></i>
                                                </h5>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>







                            <li className="nav-item"><span className="nav-link"><a onClick={closeDropdownOnMobile} href="https://sbataxconsultants.com/blog/"> Blog </a></span></li>

                            <li className="nav-item"><span className="nav-link"><Link onClick={closeDropdownOnMobile} to="./contact-us"> Contact Us </Link></span></li>


                            <li className="nav-item"><span className="nav-link btn "><Link className="talkbtn" onClick={closeDropdownOnMobile} to="https://api.whatsapp.com/send?phone=+1%20469%20722%205480&text=Hi%20I%20have%20query%20about%20%20"> TALK TO US </Link></span></li>

                            {/* <li className="nav-item"><span className="nav-link"><Link  onClick={closeDropdownOnMobile} to="./"> Upload Files </Link></span></li> */}
                        </ul>

                    </div >
                </div >
            </nav >


        </>
    );
}
